module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "integral-class"
  }, [_c('div', {
    staticClass: "bg-img"
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('span', [_vm._v("我的账户(" + _vm._s(_vm.token) + ")")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("可用积分统计截止2021年1月21日")])]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', [_c('div', [_vm._v(_vm._s(_vm.integral.accumulative || 0))]), _vm._v(" "), _c('div', [_vm._v("累计积分")])]), _vm._v(" "), _c('div', [_c('div', [_vm._v(_vm._s(_vm.integral.usable || 0))]), _vm._v(" "), _c('div', [_vm._v("可用积分")])]), _vm._v(" "), _c('div', [_c('div', [_vm._v(_vm._s(_vm.integral.conversion || 0))]), _vm._v(" "), _c('div', [_vm._v("已兑换积分")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "兑换礼品",
      "name": "first"
    }
  }, [_c('div', {
    staticClass: "overflow-body"
  }, [_c('Integral', {
    attrs: {
      "usable": _vm.integral.usable
    },
    on: {
      "exchange": _vm.exchange
    }
  })], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "兑换记录",
      "name": "second"
    }
  }, [_c('div', {
    staticClass: "overflow-body"
  }, [_c('Record', {
    ref: "record"
  })], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "兑换规则说明",
      "name": "third"
    }
  }, [_c('div', {
    staticClass: "third-class"
  }, [_vm._v("\n          一、\n          用户使用EICAD软件所产生的积分，所有权归江苏狄诺尼所有。用户对个人使用软件产生的积分不享有分配、转移、提现、过户等权益。积分兑换的商品我司不提供任何报销单据，由此产生的个人税费等法律问题由用户承担。\n          "), _c('br'), _vm._v("二、\n          我司有权对参加积分兑换活动的用户进行资格复核，如有违规操作行为或不满足活动要求的用户，我司有权在不通知用户的情况下，取消其兑换资格，并对已经兑换的积分清零；\n          "), _c('br'), _vm._v("三、\n          本次活动已兑换积分、未使用积分及未参加此次活动的用户个人积分，我司有权做扣除、清零及不累计参加后续积分活动的处理；\n          "), _c('br'), _vm._v("四、 我司对用户参加的积分兑换活动，享有包括但不限于推广、宣传、刊登、展示、画册制作等权利。\n          "), _c('br'), _vm._v("五、 本次活动最终解释权归江苏狄诺尼信息技术有限责任公司所有。\n        ")])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46fae04c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/integral/index.vue
// module id = 1122
// module chunks = 1